import type { FaireProductEntity } from "../../entity_types/product";

export const bath_6: FaireProductEntity = {
  token: "bath-6",
  type: "product",
  name: "Mint Shampoo Bar",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/43128be521c1b7639d3f9404deeb68c2460546c0bc51064bf9746d4f47abbcbe.webp",
  priceDollars: 11,
  msrpDollars: 18,
  freeShipping: false,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
